import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaNecesidadFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC. NECESIDAD' htmlFor='date-fechaNecesidad' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaNecesidad'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-fechaNecesidad'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaNecesidadFormGroup)
